document.addEventListener("DOMContentLoaded", function() {
  // Pamatcena un parametri
  const basePrice = 100; // Bāzes cena
  const pricePerUnit = 0.5; // Cenas pieaugums uz vienību

  document.querySelector("#length").addEventListener("input", updatePrice);
  document.querySelector("#width").addEventListener("input", updatePrice);
  document.querySelector("#add-to-cart-button").addEventListener("click", addToCart);

  function updatePrice() {
    const length = parseFloat(document.getElementById("length").value);
    const width = parseFloat(document.getElementById("width").value);
    const totalPrice = basePrice + (length * width * pricePerUnit);

    document.getElementById("calculated-price").textContent = "€" + totalPrice.toFixed(2);
  }

  function addToCart() {
    const length = parseFloat(document.getElementById("length").value);
    const width = parseFloat(document.getElementById("width").value);
    const totalPrice = basePrice + (length * width * pricePerUnit);

    // Iegūstam grozu
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Ja produkts jau ir grozā, atjaunojam tā cenu
        const lineItem = cart.items.find(item => item.product_id === 15035178484099); // 123456789 aizvieto ar produkta ID

        if (lineItem) {
          // Atjaunojam cenu
          updateLineItem(lineItem.id, totalPrice);
        } else {
          // Pievienojam jaunu preci ar jauno cenu
          addNewLineItem(totalPrice);
        }
      });
  }

  function updateLineItem(lineItemId, price) {
    // Atjauninām produkta cenu grozā
    fetch(`/cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineItemId,
        properties: {
          price: 200
        }
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Groza cena atjaunināta:', cart);
      alert('Cena ir atjaunināta!');
    });
  }

  function addNewLineItem(price) {
    const productData = {
      id: 55055157428611, // Aizvieto ar savu produkta ID
      quantity: 1,
      properties: {
        price: 200
      }
    };

    // Pievienojam jaunu preci ar aprēķināto cenu
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(productData)
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Prece pievienota grozam:', cart);
      alert('Prece ir pievienota grozam!');
    });
  }
});